import { render, staticRenderFns } from "./ItemSelectByFile2.vue?vue&type=template&id=1bb0702b&scoped=true&"
import script from "./ItemSelectByFile2.vue?vue&type=script&lang=js&"
export * from "./ItemSelectByFile2.vue?vue&type=script&lang=js&"
import style0 from "./ItemSelectByFile2.vue?vue&type=style&index=0&id=1bb0702b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb0702b",
  null
  
)

export default component.exports